module.exports = __webpack_public_path__ + "static/media/qh_codebook.712c9103.pdf";